var map = {
	"./Barchart": 33,
	"./Barchart.jsx": 33,
	"./Carousel": 36,
	"./Carousel.jsx": 36,
	"./CompactForm": 37,
	"./CompactForm.jsx": 37,
	"./CompactForm1": 38,
	"./CompactForm1.jsx": 38,
	"./CreatePostForm": 18,
	"./CreatePostForm.jsx": 18,
	"./CustomButton": 39,
	"./CustomButton.jsx": 39,
	"./CustomSelect": 40,
	"./CustomSelect.jsx": 40,
	"./Details": 41,
	"./Details.jsx": 41,
	"./Discussion": 42,
	"./Discussion.jsx": 42,
	"./DropdownButton": 19,
	"./DropdownButton.jsx": 19,
	"./DropdownButton1": 15,
	"./DropdownButton1.jsx": 15,
	"./Dropzone1": 43,
	"./Dropzone1.jsx": 43,
	"./Dropzone2": 44,
	"./Dropzone2.jsx": 44,
	"./EditableTable": 45,
	"./EditableTable.jsx": 45,
	"./Files": 46,
	"./Files.jsx": 46,
	"./Files1": 47,
	"./Files1.jsx": 47,
	"./FilesByDates": 48,
	"./FilesByDates.jsx": 48,
	"./FilesGrid": 49,
	"./FilesGrid.jsx": 49,
	"./Fileupload": 50,
	"./Fileupload.jsx": 50,
	"./Fileupload1": 51,
	"./Fileupload1.jsx": 51,
	"./Form": 52,
	"./Form.jsx": 52,
	"./Form1": 53,
	"./Form1.jsx": 53,
	"./Form2": 54,
	"./Form2.jsx": 54,
	"./FormWithTable": 55,
	"./FormWithTable.jsx": 55,
	"./Htmleditor": 56,
	"./Htmleditor.jsx": 56,
	"./IntroComponent": 57,
	"./IntroComponent.jsx": 57,
	"./Kanban": 58,
	"./Kanban.jsx": 58,
	"./LazyLoadingTable": 59,
	"./LazyLoadingTable.jsx": 59,
	"./LineChart1": 74,
	"./LineChart1.jsx": 74,
	"./Linechart": 62,
	"./Linechart.jsx": 62,
	"./Listing": 63,
	"./Listing.jsx": 63,
	"./Multiselect": 64,
	"./Multiselect.jsx": 64,
	"./NewForm": 65,
	"./NewForm.jsx": 65,
	"./Picker": 14,
	"./Picker.jsx": 14,
	"./Piechart": 66,
	"./Piechart.jsx": 66,
	"./Post": 20,
	"./Post.jsx": 20,
	"./SocialMediaFeed": 67,
	"./SocialMediaFeed.jsx": 67,
	"./Table": 68,
	"./Table.jsx": 68,
	"./Table1": 69,
	"./Table1.jsx": 69,
	"./Timeline": 70,
	"./Timeline.jsx": 70,
	"./Timeline1": 71,
	"./Timeline1.jsx": 71,
	"./Todolist": 72,
	"./Todolist.jsx": 72,
	"./Todolist1": 73,
	"./Todolist1.jsx": 73
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;